import { AuthenticatedApiClient } from '@guiker/payment-verification-shared'
import { useAuthenticatedApiClient } from '@guiker/react-framework'

export const useAuthenticatedPaymentVerificationApiClient = useAuthenticatedApiClient(AuthenticatedApiClient)
